import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { catchError, exhaustMap, map } from 'rxjs/operators'
import { of } from 'rxjs'
import { LoadCharges, LoadChargesComplete } from './billing.actions'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'
import { BillingService } from './billing.service'

@Injectable()
export class BillingEffects {
  // the store only feeds the dashboard activity feed, which needs recent charges, not the full history
  @Effect()
  loadCharges$ = this.actions$.pipe(
    ofType(LoadCharges),
    exhaustMap(() =>
      this.billingService.chargesPage({ limit: 50 }).pipe(
        map(({ data }) => LoadChargesComplete({ billings: data })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private billingService: BillingService) {}
}
